import classNames from 'classnames';
import React, { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import './ConditionalLink.styles.scss';

const BASE_CLASS = 'conditional-link';

type ConditionalLinkProps = {
  isDisabled?: boolean;
  disabledClassName?: string;
  linkClassName?: string;
} & LinkProps;

const ConditionalLink: FC<ConditionalLinkProps> = ({
  isDisabled,
  to,
  children,
  disabledClassName,
  linkClassName,
  ...rest
}) => {
  const disabledClasses = classNames(
    `${BASE_CLASS}--disabled`,
    'ncoded-button',
    disabledClassName,
  );
  const linkClasses = classNames(BASE_CLASS, 'as-button', linkClassName);

  return isDisabled ? (
    <span className={disabledClasses}>{children}</span>
  ) : (
    <Link
      className={linkClasses}
      to={to}
      onClick={(e) => e.stopPropagation()}
      {...rest}
    >
      {children}
    </Link>
  );
};

export default ConditionalLink;
